"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HelpSupport = function HelpSupport(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 26 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 26 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Help Support' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Help Support' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 26 26"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access",
    transform: "translate(-22.000000, -791.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Help-&-Support",
    transform: "translate(23.000000, 792.000000)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "Oval-Copy-4",
    stroke: color,
    strokeWidth: "1.75",
    cx: "12",
    cy: "12",
    r: "12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.2878125,6.275 C13.5711523,6.275 14.6007253,6.54041401 15.3765625,7.07125 C16.1523997,7.60208599 16.5403125,8.36916165 16.5403125,9.3725 C16.5403125,10.3875051 16.2398988,11.160414 15.6390625,11.69125 C15.0382262,12.222086 14.2361508,12.5399995 13.2328125,12.645 L13.1103125,14.29 L10.9753125,14.29 L10.8703125,11.6475 C11.9786514,11.5308328 12.7719768,11.3179182 13.2503125,11.00875 C13.7286482,10.6995818 13.9678125,10.2708361 13.9678125,9.7225 C13.9678125,9.26749772 13.8132307,8.91458459 13.5040625,8.66375 C13.1948943,8.41291541 12.7369822,8.2875 12.1303125,8.2875 C11.5236428,8.2875 11.0307311,8.45958161 10.6515625,8.80375 C10.2723939,9.14791839 10.0594794,9.63499685 10.0128125,10.265 L7.7378125,9.32 C7.88947992,8.386662 8.34739201,7.64583607 9.1115625,7.0975 C9.87573299,6.54916392 10.9344724,6.275 12.2878125,6.275 Z M12.0428125,15.4275 C12.5094815,15.4275 12.8769778,15.5499988 13.1453125,15.795 C13.4136472,16.0400012 13.5478125,16.3724979 13.5478125,16.7925 C13.5478125,17.2125021 13.4136472,17.5449988 13.1453125,17.79 C12.8769778,18.0350012 12.5094815,18.1575 12.0428125,18.1575 C11.5761435,18.1575 11.2115638,18.0350012 10.9490625,17.79 C10.6865612,17.5449988 10.5553125,17.2125021 10.5553125,16.7925 C10.5553125,16.3724979 10.6865612,16.0400012 10.9490625,15.795 C11.2115638,15.5499988 11.5761435,15.4275 12.0428125,15.4275 Z",
    id: "?",
    fill: color
  })))));
};
HelpSupport.propTypes = _index.iconProps;
var _default = HelpSupport;
exports["default"] = _default;